import { useQuery } from "@apollo/client";

import { SectionProps } from "../../common/types";
import { Blobs, Blob } from "../../common/Blob";
import { UKCountryName } from "../../../util";

import { locationToLocationOption } from "@hire/util/locations";
import { JobStructuredLocationsDocument, Location } from "@hire/schema";

export function JobLocations({
  fields: {
    hasOfficeLocationPreferences,
    hasRemoteLocationPreferences,
    officeLocationPreferences,
    remoteLocationPreferences,
    visibleStructuredLocationPreferences,
  },
}: SectionProps) {
  let locationPreferences: Location[] = [];

  const { data } = useQuery(JobStructuredLocationsDocument, {
    variables: {
      country: UKCountryName,
    },
  });

  const newLocations =
    data?.jobStructuredLocations
      .filter(location =>
        visibleStructuredLocationPreferences.includes(location.id)
      )
      .map(location => location.name) || [];

  if (hasOfficeLocationPreferences) {
    locationPreferences = officeLocationPreferences;
  }
  if (hasRemoteLocationPreferences) {
    locationPreferences = locationPreferences.concat(remoteLocationPreferences);
  }

  const allLocations = [
    ...locationPreferences.map(l => locationToLocationOption(l)?.label ?? ""),
    ...newLocations,
  ];

  return allLocations.length > 0 ? (
    <Blobs>
      {allLocations.map((location, i) => (
        <Blob bold={i === 0} key={i}>
          {location}
        </Blob>
      ))}
    </Blobs>
  ) : (
    <Blobs>
      <Blob key={0}>[Location]</Blob>
    </Blobs>
  );
}
